import React from "react";
import "./scorebox.css";
import "./FillIntheBlanks.css";
import InfoTooltip from "../../../InfoTooltip";
import TipButton from "../../../TipButton";
import StudentInfoTooltip from "../../../StudentInfoTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLeftRight } from "@fortawesome/free-solid-svg-icons";
import { handleScoreChange } from "./helpers/scoreHelpers";
import CategoryTags from "./CategoryTags";

const FillInTheBlanks = React.memo(
  ({
    question,
    onChange,
    border,
    score,
    isStudentView,
    studentResponse,
    tip,
    questionCategories = [],
    showCategories = true,
    onFlip,
  }) => {
    const onScoreChange = handleScoreChange(onChange);

    const handleQuestionChange = (e) => {
      const newQuestion = e.target.value;
      const newBlanks = newQuestion.match(/\[.*?\]/g) || [];
      const newCorrectAnswers = newBlanks.map((blank) => blank.slice(1, -1));
      onChange({
        question: newQuestion,
        correctAnswers: newCorrectAnswers,
      });
    };

    const renderQuestion = () => {
      if (!question && isStudentView) {
        return (
          <div className="empty-question-placeholder">
            <p>This question has no content.</p>
          </div>
        );
      }

      if (!question) return null;

      const parts = question.split(/(\[.*?\])/g);
      const blankCount = parts.filter(
        (part) => part.startsWith("[") && part.endsWith("]")
      ).length;
      const pointValue = blankCount > 0 ? score / blankCount : 0;

      return parts.map((part, index) => {
        if (part.startsWith("[") && part.endsWith("]")) {
          const answer = part.slice(1, -1);
          if (isStudentView) {
            return (
              <input
                key={index}
                type="text"
                value={
                  studentResponse && studentResponse.answer
                    ? studentResponse.answer[Math.floor(index / 2)] || ""
                    : ""
                }
                onChange={(e) =>
                  handleStudentResponse(Math.floor(index / 2), e.target.value)
                }
                style={{ width: `${Math.max(answer.length * 8, 60)}px` }}
              />
            );
          } else {
            return (
              <span key={index} className="question-display-blank-container">
                <span
                  className="question-display-blank"
                  style={{ minWidth: `${Math.max(answer.length * 8, 60)}px` }}
                >
                  {answer}
                  <span className="point-indicator">
                    {window.matchMedia("(orientation: portrait)").matches
                      ? `+${pointValue.toFixed(2)} p`
                      : `+${pointValue.toFixed(2)} point!`}
                  </span>
                </span>
              </span>
            );
          }
        }
        return <span key={index}>{part}</span>;
      });
    };

    const handleStudentResponse = (index, value) => {
      if (isStudentView) {
        const newAnswer =
          studentResponse && studentResponse.answer
            ? [...studentResponse.answer]
            : [];
        newAnswer[index] = value;
        onChange({
          type: "FillInTheBlanks",
          answer: newAnswer,
        });
      }
    };

    const handleAddBrackets = () => {
      const textarea = document.querySelector("textarea");
      if (textarea) {
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const newQuestion =
          question.substring(0, start) + "[]" + question.substring(end);

        onChange({
          question: newQuestion,
          correctAnswers: [],
        });

        // Set cursor position inside brackets
        setTimeout(() => {
          textarea.selectionStart = start + 1;
          textarea.selectionEnd = start + 1;
          textarea.focus();
        }, 0);
      }
    };

    return (
      <div className={`question-container ${border}`}>
        <div className="question-header">
          {isStudentView ? (
            <>
              <div className="question-display">{renderQuestion()}</div>
              <StudentInfoTooltip type="Fill in the Blanks" />
            </>
          ) : (
            <>
              <textarea
                value={question}
                onChange={handleQuestionChange}
                placeholder="Enter your question with blanks in square brackets, e.g., The capital of France is [Paris]. For multiple correct answers, separate with '/', e.g., [pass out/faint]."
              />
              <InfoTooltip type="Fill in the Blanks" />
            </>
          )}
        </div>
        {!isStudentView && (
          <div className="question-display">{renderQuestion()}</div>
        )}
        <div className="category-tags-container">
          <CategoryTags
            categories={questionCategories}
            onChange={(newCategories) =>
              onChange({
                questionCategories: newCategories,
              })
            }
            isStudentView={isStudentView}
            showCategories={showCategories}
          />
        </div>
        <div className="question-footer">
          <div className="question-footer-flex">
            <div
              className={
                isStudentView ? "student-button-wrapper" : "button-wrapper"
              }
            >
              {!isStudentView && (
                <button
                  onClick={handleAddBrackets}
                  className="question-footer-button"
                >
                  Add Blank
                </button>
              )}
            </div>
            <TipButton
              tip={tip}
              onChange={onChange}
              isStudentView={isStudentView}
              onFlip={onFlip}
            />
            <div className="scorebox-container">
              <label htmlFor="score">Score:</label>
              <input
                type="number"
                id="score"
                value={score}
                onChange={onScoreChange}
                min="0"
                step="1"
                readOnly={isStudentView}
                className={isStudentView ? "student-view" : ""}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default FillInTheBlanks;
